// copied from aem repo
var screenSizes = {
  isMobile: function isMobile() {
    return window.matchMedia ? window.matchMedia('(max-width: 650px)').matches : false;
  },
  isTabletAndUnder: function isTabletAndUnder() {
    return window.matchMedia ? window.matchMedia('(max-width: 1200px)').matches : false;
  },
  isTabletAndOver: function isTabletAndOver() {
    return window.matchMedia ? window.matchMedia('(min-width: 651px)').matches : false;
  },
  isTablet: function isTablet() {
    return window.matchMedia ? window.matchMedia('(min-width: 651px) and (max-width: 1200px)').matches : false;
  },
  isDesktop: function isDesktop() {
    return window.matchMedia ? window.matchMedia('(min-width: 1201px)').matches : false;
  }
};
export default screenSizes;